<style lang="less" scoped>
.medicine-list {
  width: 100%;
  > li {
    display: flex;
    width: 100%;
    align-items: center;
    .medicine-name {
      flex: 1;
    }
  }
}
.search-form {
  display: flex;
  .search-input {
    flex: 1;
  }
  .search-button {
    padding-left: 10px;
    button {
      height: 100%;
    }
  }
}
.description {
  color: gray;
  font-size: .9em;
  padding-left: 10px;
}
</style>

<template lang="pug">
  form(method="get" action="#")
    .search-cover.dialog-content-cover
      form.search-form(method="post" action="#" @submit.prevent="submit")
        div.search-input
          el-input(type="text" v-model="keyword" placeholder="검색")
        div.search-button
          el-button(type="success" native-type="submit") 검색
    .medicine-list-cover
      ul.medicine-list
        li.dialog-content-cover(
          @click="selectIngredient(ingredient)",
          v-for="ingredient in ingredients",
          v-if="!ingredient.unavailable")
          span.medicine-name {{ingredient.name}}
            span.description {{ingredient.description}}
          span
            img(
              src="@/assets/chevron-left-small@2x.png",
              style="width: 16px")
</template>

<script>
export default {
  props: ['ingredients'],
  data() {
    return {
      keyword: null,
    };
  },
  methods: {
    async selectIngredient(obj) {
      this.$emit('selectIngredient', obj);
    },
    async resetModal() {
      this.keyword = null;
    },
    // async loadData() {
    //   let destination = '/ingredients';
    //   if (this.keyword) {
    //     destination = destination.concat('?q='.concat(this.keyword));
    //   }
    //   const { data } = await this.$http.get(destination);
    //   return data;
    // },
    async submit() {
      // this.ingredients = await this.loadData();
      this.$emit('search', this.keyword);
    },
  },
  async mounted() {
    // const loadedIngredients = await this.$http.get('/ingredients');
    // this.ingredients = loadedIngredients.data;
    // await this.resetModal();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal/modal_present_choose.vue